const t = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], s = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableClock", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], l = ["minDateTime", "maxDateTime"], D = [...t, ...s, ...l], n = (a) => D.reduce((i, e) => (a.hasOwnProperty(e) && (i[e] = a[e]), i), {});
export {
  l as DATE_TIME_VALIDATION_PROP_NAMES,
  t as DATE_VALIDATION_PROP_NAMES,
  s as TIME_VALIDATION_PROP_NAMES,
  n as extractValidationProps
};
//# sourceMappingURL=extractValidationProps.mjs.map
